<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body="{height}">
        <v-sheet class="pt-3 px-3" v-if="!!storeAggregate && !!storeAggregate.rootData && storeDetail.uidItem">
          <v-row>
            <v-col cols="3">
              <v-card ref="originalCard" :height="330">
                <v-system-bar>Original BOM data</v-system-bar>
                <v-sheet class="px-1 py-2">
                  <v-row dense>
                    <v-col cols="3">
                      <CommonFieldNumber
                          dense
                          v-model.number="currentItem.original_qty"
                          label="QTY"
                          hide-details
                          :readonly="true"
                          filled
                      >
                      </CommonFieldNumber>
                    </v-col>
                    <v-col>
                      <CommonFieldString
                          dense
                          v-model="currentItem.original_mpn"
                          outlined
                          label="MPN"
                          hide-details
                          :readonly="true"
                          filled
                      >
                      </CommonFieldString>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col>
                      <CommonFieldString
                          dense
                          v-model="currentItem.original_designator"
                          outlined
                          label="Designator"
                          hide-details
                          :readonly="true"
                          filled
                      >
                      </CommonFieldString>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="6">
                      <CommonFieldString
                          dense
                          v-model="currentItem.original_article"
                          outlined
                          label="Article"
                          hide-details
                          :readonly="true"
                          filled
                      >
                      </CommonFieldString>
                    </v-col>
                    <v-col>
                      <CommonFieldString
                          dense
                          v-model="currentItem.original_customer_article"
                          outlined
                          label="Customer article"
                          hide-details
                          :readonly="true"
                          filled
                      >
                      </CommonFieldString>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col>
                      <CommonFieldText
                          dense
                          v-model="currentItem.original_description"
                          label="Description"
                          hide-details
                          rows="5"
                          :readonly="true"
                          filled
                      >
                      </CommonFieldText>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card ref="originalCard" :height="330">
                <v-system-bar>BOM data</v-system-bar>
                <v-sheet class="px-1 py-2">
                  <v-row dense>
                    <v-col cols="3">
                      <CommonFieldNumber
                          dense
                          v-model.number="currentItem.qty"
                          label="QTY"
                          hide-details
                          :filled="currentItem.qty === currentItem.original_qty"
                      >
                      </CommonFieldNumber>
                    </v-col>
                    <v-col>
                      <CommonFieldString
                          dense
                          v-model="currentItem.mpn"
                          outlined
                          label="MPN"
                          hide-details
                          :filled="currentItem.mpn === currentItem.original_mpn"
                      >
                      </CommonFieldString>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col>
                      <CommonFieldString
                          dense
                          v-model="currentItem.designator"
                          outlined
                          label="Designator"
                          hide-details
                          :filled="currentItem.designator === currentItem.original_designator"
                      >
                      </CommonFieldString>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="6">
                      <CommonFieldString
                          dense
                          v-model="currentItem.article"
                          outlined
                          label="Article"
                          hide-details
                          :filled="currentItem.article === currentItem.original_article"
                      >
                      </CommonFieldString>
                    </v-col>
                    <v-col>
                      <CommonFieldString
                          dense
                          v-model="currentItem.customer_article"
                          outlined
                          label="Customer article"
                          hide-details
                          :filled="currentItem.customer_article === currentItem.original_customer_article"
                      >
                      </CommonFieldString>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col>
                      <CommonFieldText
                          dense
                          v-model="currentItem.description"
                          label="Description"
                          hide-details
                          rows="3"
                          :filled="currentItem.description === currentItem.original_description"
                      >
                      </CommonFieldText>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="3">
                      <v-checkbox
                          v-model="currentItem.do_not_place"
                          label="DNP"
                          class="mt-0"
                          tooltip="Do not place"
                          hide-details
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="3">
                      <v-checkbox
                          v-model="currentItem.provided_by_customer"
                          label="PBC"
                          class="mt-0"
                          tooltip="Provided by customer"
                          hide-details
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card ref="originalCard" :height="330">
                <v-system-bar>Article</v-system-bar>
                <v-sheet class="px-1 pt-2" v-if="!!currentItem.component_uid">
                  <v-row dense>
                    <v-col cols="4">
                      <CommonFieldString
                          dense
                          v-model="storeAggregate.rootData[currentItem.component_uid].article_display"
                          outlined
                          label="Article"
                          hide-details
                      >
                      </CommonFieldString>
                    </v-col>
                    <v-col cols="8">
                      <CommonFieldString
                          dense
                          v-model="storeAggregate.rootData[currentItem.component_uid].mpn"
                          outlined
                          label="MPN"
                          hide-details
                      >
                      </CommonFieldString>
                    </v-col>
                  </v-row>
                  <v-row dense
                         v-if="!!storeAggregate.rootData[currentItem.component_uid].case_package_uid">
                    <v-col cols="4">
                      <CommonFieldString
                          dense
                          v-model="storeAggregate.rootData[storeAggregate.rootData[currentItem.component_uid].case_package_uid].case_package_type"
                          outlined
                          label="Type"
                          hide-details
                      >
                      </CommonFieldString>
                    </v-col>
                    <v-col cols="8">
                      <CommonFieldString
                          dense
                          v-model="storeAggregate.rootData[storeAggregate.rootData[currentItem.component_uid].case_package_uid].name"
                          outlined
                          label="MPN"
                          hide-details
                      >
                      </CommonFieldString>
                    </v-col>
                  </v-row>
                  <v-row dense
                         v-if="!!storeAggregate.rootData[currentItem.component_uid].subcategory_uid">
                    <v-col cols="4">
                      <CommonFieldString
                          v-if="!!storeAggregate.rootData[storeAggregate.rootData[currentItem.component_uid].subcategory_uid].category_uid"
                          dense
                          v-model="storeAggregate.rootData[storeAggregate.rootData[storeAggregate.rootData[currentItem.component_uid].subcategory_uid].category_uid].category"
                          outlined
                          label="Category"
                          hide-details
                      >
                      </CommonFieldString>
                    </v-col>
                    <v-col cols="8">
                      <CommonFieldString
                          dense
                          v-model="storeAggregate.rootData[storeAggregate.rootData[currentItem.component_uid].subcategory_uid].subcategory"
                          outlined
                          label="Subcategory"
                          hide-details
                      >
                      </CommonFieldString>
                    </v-col>
                  </v-row>
                  <v-row dense
                         v-if="!!storeAggregate.uid_dict[currentItem.uid] && storeAggregate.uid_dict[currentItem.uid].component_uid">
                    <v-col>
                      <CoreComponentAttrList
                          v-if="!!currentItem && !!currentItem.component_uid && !!storeAggregate.rootData &&
                          storeAggregate.rootData[currentItem.component_uid]"
                          v-model="storeAggregate.rootData[currentItem.component_uid].key_attributes"
                          :height="150"
                          :enable-search="false"
                          :headers="headersAttr"
                      ></CoreComponentAttrList>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card ref="originalCard" :height="330">
                <v-system-bar>QA</v-system-bar>
                <CommonHTMXComponent
                    :iframe-src="'/component/quality_control_params/bom_sheet/' + storeDetail.uidItem + '/'"
                    :height="290"></CommonHTMXComponent>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <ComponentTable
                title="Component"
                :height="height - 510"
                :headers="headersComponent"
                :store-name="storeComponentTableName"
                :show-select="false"
            >
              <template v-slot:footer.prepend>{{ '' }}</template>
              <template v-slot:item.action="{ item }">
                <v-icon v-if="currentItem.component_uid === item.uid">mdi-link-box</v-icon>
                <v-icon v-else @click="onBind(item)">mdi-link-box-outline</v-icon>
              </template>
            </ComponentTable>
          </v-row>

        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CommonFieldNumber from "@/components/Common/CommonFieldNumber";
import CommonFieldText from "@/components/Common/CommonFieldText";
import ComponentTable from "@/components/CoreComponent/Component/ComponentTable";
import {v4 as uuidv4} from "uuid";
import {useTableStore} from "@/components/Common/CommonTable";
import CoreSpecAttrComponentTable from "@/components/CoreComponent/SpecAttrComponent/CoreSpecAttrComponentTable";
import CoreComponentAttrList from "@/components/CoreComponent/SpecAttrComponent/CoreComponentAttrList.vue";
import CommonHTMXComponent from "@/components/Common/CommonHTMXComponent.vue";

export default {
  name: "CoreBomSheetDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'CoreBomSheetDetail'},
    dtoDetailQuery: {default: 'BomSheetDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'BomSheetActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'BomSheetSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'BomSheetValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'BomSheetDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'CoreBomSheetTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonHTMXComponent,
    CoreComponentAttrList,
    CommonDetail,
    CommonFieldString,
    CommonFieldNumber,
    CommonFieldText,
    ComponentTable,
    CoreSpecAttrComponentTable,
  },

  computed: {
    currentUid() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
    currentItem() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
    product_uid() {
      if (!!currentItem && !!currentItem.customer_order_uid &&
          !!this.storeAggregate.rootData[currentItem.customer_order_uid] &&
          !!this.storeAggregate.rootData[currentItem.customer_order_uid].product_uid &&
          !!this.storeAggregate.rootData[this.storeAggregate.rootData[currentItem.customer_order_uid].product_uid])
        return this.storeAggregate.rootData[currentItem.customer_order_uid].product_uid
      return null
    },
    product_article_number() {
      if (!!this.product_uid)
        return this.storeAggregate.rootData[this.product_uid].article_number
      else
        return null
    },
    customer_uid() {
      if (!!currentItem && !!currentItem.customer_order_uid &&
          !!this.storeAggregate.rootData[currentItem.customer_order_uid] &&
          !!this.storeAggregate.rootData[currentItem.customer_order_uid].customer_uid &&
          !!this.storeAggregate.rootData[this.storeAggregate.rootData[currentItem.customer_order_uid].customer_uid])
        return this.storeAggregate.rootData[currentItem.customer_order_uid].customer_uid
      return null
    },
    customer_name() {
      if (!!this.customer_uid)
        return this.storeAggregate.rootData[this.customer_uid].name
      else
        return null
    },
    current_mpn() {
      if (!!this.currentItem)
        return this.currentItem.mpn
      return null
    },
    uid_dict_component_uid() {
      if (!!this.currentItem && !!this.storeAggregate.uid_dict[this.currentItem.uid])
        return this.storeAggregate.uid_dict[this.currentItem.uid].component_uid
      else
        return null
    },
    component_uid() {
      if (!!this.currentItem)
        return this.currentItem.component_uid
      else
        return null
    },
    component_item() {
      if (!!this.component_uid)
        return this.storeAggregate.rootData[this.currentItem.component_uid]
      else
        return null
    },
    subcategory_uid() {
      if (!!this.component_item)
        return this.component_item.subcategory_uid
      else
        return null
    },
  },

  watch: {
    currentUid: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          // console.log('currentUid', this.currentUid, this.current_mpn)
          this.setSearch()
        }
      },
      deep: true
    },
    uid_dict_component_uid: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue)
          this.filterQueryMainSpecAttr()
      },
      deep: true
    },
  },

  methods: {
    onBind(item) {
      if (!!this.currentItem)
        this.currentItem.component_uid = item.uid
    },
    setSearch() {
      if (!!this.component_item) {
        this.storeComponentTable.search = null
        return
      }
      if (!!this.currentItem && !!this.currentItem.customer_article) {
        this.storeComponentTable.search = this.currentItem.customer_article
        return
      }
      if (!!this.currentItem && !!this.currentItem.article) {
        this.storeComponentTable.search = this.currentItem.article
        return
      }
      if (!!this.currentItem && !!this.currentItem.mpn) {
        this.storeComponentTable.search = this.currentItem.mpn
        return
      }
    }
  }
  ,

  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
    this.storeComponentTable = useTableStore(this.storeComponentTableName)()
    this.setSearch()

  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      storeComponentTable: null,
      storeComponentTableName: uuidv4(),
      headersComponent: [
        {text: 'A', value: 'action', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'S', value: 'row_statuses', sortable: false, filterable: true, divider: true, width: 10, type: 'status'},
        {text: 'T', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 'G', value: 'is_group', sortable: true, filterable: true, divider: true, width: 30, type: 'bool'},
        {text: 'Article', value: 'article_display', sortable: true, filterable: true, divider: true, width: 50},
        {text: 'Alias', value: 'alias', sortable: true, filterable: true, divider: true, width: 150},
        {text: 'MPN', value: 'mpn', sortable: true, filterable: true, divider: true, width: 150},
        {
          text: 'case_package',
          value: 'case_package_uid',
          article_type: true,
          filterable: true,
          divider: true,
          width: 50
        },
        {
          text: 'CasePackage type',
          value: 'case_package__case_package_type',
          sortable: false,
          filterable: true,
          divider: true,
          width: 50
        },
        {
          text: 'subcategory',
          value: 'subcategory_uid',
          article_type: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {
          text: 'Category',
          value: 'subcategory__category__category',
          sortable: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {
          text: 'Article parameters',
          value: 'main_attributes',
          sortable: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {text: 'supply_type', value: 'supply_type', sortable: false, filterable: true, divider: true, width: 100},
        {text: 'image', value: 'image', sortable: false, filterable: true, divider: true, width: 100},
        {text: 'description', value: 'description', sortable: false, filterable: true, divider: true, width: 300},
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ],
      mainSpecAttrComponentHeaders: [
        {
          text: 'Attribute name',
          value: 'attribute__name',
          sortable: false,
          filterable: true,
          divider: false,
          width: 100
        },
        {text: 'Display value', value: 'display_value', sortable: false, filterable: true, divider: false, width: 60},
      ],
      headersAttr: [
        {text: 'group', value: 'group', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'name', value: 'name', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'value', value: 'value', sortable: false, filterable: true, divider: true, width: 50},
      ]
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>